import { memo, useState } from 'react';
import cn from 'classnames';
import BrIcons from '@components/BrIcons';
import BrButton from '@components/BrButton';
import BrOutsideAlerter from '@components/BrOutsideAlerter';
import './BrDropDownDualRangeSlider.scss';
import BrDualRangeSlider from './BrDualRangeSlider';

type BrDropDownDualRangeSliderProps = {
  min: number;
  max: number;
  stepValue: number;
  selectedMin: number;
  selectedMax: number;
  className: string;
  onDone: ({ min, max }: {min: number, max: number}) => void;
};

const BrDropDownDualRangeSlider = (props: BrDropDownDualRangeSliderProps): JSX.Element => {
  const { min = 0, max = 1, selectedMin = 0, selectedMax = 1, stepValue = 0.01, className, onDone } = props;
  const [minVal, setMinVal] = useState(selectedMin);
  const [maxVal, setMaxVal] = useState(selectedMax);
  const [isActive, setIsActive] = useState(false);

  const classname = cn('br-multi-select-dropdown-menu', className, { active: isActive });

  const handleClickOutside = () => {
    setIsActive(false);
  };

  const handleClickOpenBtn = () => {
    setIsActive(true);
  };

  const handleCloseDropdown = ({ min, max }: {min: number, max: number}) => {
    setMinVal(min);
    setMaxVal(max);
    onDone({ min, max });
    handleClickOutside();
  };

  const btnTitle = `${minVal} - ${maxVal}`;
  const renderBtnTitle = (
    <div className="multi-select-dropdown-title" title={btnTitle}>
      <div className={cn('item-title')}>{btnTitle}</div>
      <BrIcons.DownCaret isSubComp />
    </div>
  );

  return (
    <BrOutsideAlerter className={className} callbackFunc={handleClickOutside}>
      <div className={classname} data-id="br-dropdown-dual-range-slider">
        <BrButton title={renderBtnTitle} isSubComp tooltipText={btnTitle} onClick={handleClickOpenBtn} />
        <div className="multi-select-dropdown-item-list">
          <BrDualRangeSlider
            min={min}
            max={max}
            selectedMin={selectedMin}
            selectedMax={selectedMax}
            stepValue={stepValue}
            onDone={handleCloseDropdown}
          />
        </div>
      </div>
    </BrOutsideAlerter>
  );
};

export default memo(BrDropDownDualRangeSlider);
